import { useEffect } from 'react';
import { endCustomerSessionGlobal } from './customerAuthSync.js';
import { useCustomerSession } from './CustomerSessionProvider.js';
import { useRuntimeConfig } from '../providers/RuntimeConfigProvider.js';
import { reconcileEstablishedPlatformMe } from './establishedMeValidation.js';

/** Periodic platform `/me` while tab visible + session exists. */
export function usePeriodicMeValidation(intervalMs: number): void {
  const { session } = useCustomerSession();
  const config = useRuntimeConfig();

  useEffect(() => {
    if (intervalMs <= 0 || session === null) {
      return undefined;
    }

    const expectedCustomerId = session.customerId;

    const tick = (): void => {
      if (document.visibilityState !== 'visible') {
        return;
      }
      void (async () => {
        const reconciled = await reconcileEstablishedPlatformMe(config, {
          hasMemorySession: true,
        });
        if (reconciled.action === 'ok') {
          if (reconciled.me.customerId !== expectedCustomerId) {
            // Identity changed — treat as fresh establish via peer path.
            return;
          }
          return;
        }
        if (reconciled.action === 'keep') {
          return;
        }
        await endCustomerSessionGlobal({
          broadcast: true,
          callApi: false,
          reason: 'revoked',
        });
      })().catch(() => undefined);
    };

    const id = window.setInterval(tick, intervalMs);
    return () => {
      window.clearInterval(id);
    };
  }, [config, intervalMs, session]);
}
